// GuideHome — landing page for the in-portal User Guide (/guide).
// One card per section, driven by guideSections so new sections need no edit here.
import React from 'react';
import { Link } from 'react-router-dom';
import { QuestionMarkCircleIcon, ArrowRightIcon } from '@heroicons/react/24/outline';
import { guideSections } from './guideSections';

export default function GuideHome() {
  return (
    // p-6 matches the gutter every other portal page sets for itself.
    <div className="max-w-3xl p-6">
      <div className="flex items-start gap-3 mb-2">
        <QuestionMarkCircleIcon className="h-6 w-6 text-blue-400 flex-none mt-0.5" />
        <div>
          <h1 className="text-xl font-bold text-gray-100 leading-tight">User Guide</h1>
          <p className="text-sm text-gray-500 mt-1 leading-relaxed">
            How the portal works, written for the people using it day to day.
          </p>
        </div>
      </div>

      <p className="text-sm text-gray-400 leading-relaxed mt-5 mb-6">
        Blue365Signal ingests Microsoft 365 audit logs, Defender alerts and Entra ID sign-in data,
        then runs a library of detection rules against it to surface suspicious activity. These
        guides cover how to work that output — what each screen shows, what the buttons actually
        do, and where the sharp edges are.
      </p>

      <div className="space-y-3">
        {guideSections.map((s) => {
          const Icon = s.icon;

          if (!s.available) {
            return (
              <div key={s.to} className="card flex items-start gap-4 opacity-50">
                <Icon className="h-5 w-5 text-gray-600 flex-none mt-0.5" />
                <div className="min-w-0">
                  <div className="flex items-center gap-2">
                    <span className="text-sm font-semibold text-gray-400">{s.label}</span>
                    <span className="text-[10px] uppercase tracking-wide text-gray-600 border border-gray-700 rounded px-1.5 py-0.5">
                      Coming soon
                    </span>
                  </div>
                  <p className="text-xs text-gray-600 mt-1 leading-relaxed">{s.blurb}</p>
                </div>
              </div>
            );
          }

          return (
            <Link
              key={s.to}
              to={s.to}
              className="card flex items-start gap-4 hover:border-blue-700/50 hover:bg-gray-800/30 transition-colors group"
            >
              <Icon className="h-5 w-5 text-blue-400 flex-none mt-0.5" />
              <div className="min-w-0 flex-1">
                <div className="flex items-center gap-2">
                  <span className="text-sm font-semibold text-gray-200">{s.label}</span>
                  <ArrowRightIcon className="h-3.5 w-3.5 text-gray-600 group-hover:text-blue-400 transition-colors" />
                </div>
                <p className="text-xs text-gray-500 mt-1 leading-relaxed">{s.blurb}</p>
              </div>
            </Link>
          );
        })}
      </div>
    </div>
  );
}
